/**
 * convert the input value into currency|blank string
 * @param {*} value the input number
 * @param {*} nullable when false, must return non-blank string if !value (i.e. when value equals 0 or null)
 * @param {*} locale the currecny locale format
 * @param {*} currency the currency name
 * @returns
 */
export const toLocaleCurrency = (
  value,
  nullable = false,
  locale = "it-IT",
  currency = "EUR"
) => {
  return value
    ? value.toLocaleString(locale, {
        style: "currency",
        currency: currency,
        useGrouping: true,
      })
    : !nullable
    ? parseFloat("0.00001").toLocaleString(locale, {
        style: "currency",
        currency: currency,
        useGrouping: true,
      })
    : "";
};

export const toLocaleDecimal = (value, nullable = false, locale = "it-IT") => {
  return value
    ? new Intl.NumberFormat(locale, {
        style: "decimal",
        minimumIntegerDigits: 2,
        minimumFractionDigits: 2,
      }).format(value)
    : !nullable
    ? new Intl.NumberFormat(locale, {
        style: "decimal",
        minimumIntegerDigits: 2,
        minimumFractionDigits: 2,
      }).format(parseFloat("0.00001"))
    : "";
};

export const toLocaleInteger = (value, nullable = false, locale = "it-IT") => {
  return value
    ? new Intl.NumberFormat(locale, {
        style: "decimal",
        minimumIntegerDigits: 1,
        maximumFractionDigits: 0,
      }).format(value)
    : !nullable
    ? new Intl.NumberFormat(locale, {
        style: "decimal",
        minimumIntegerDigits: 1,
        maximumFractionDigits: 0,
      }).format(parseFloat("0.00001"))
    : "";
};

// module.exports = {
//   toLocaleCurrency,
// };

/**
 * Larghezza (in caratteri) della colonna di importi in euro: il più lungo fra
 * i testi che contengono "€".
 * @param {string[]} texts
 * @returns {number}
 */
export const priceColumnWidth = (texts) =>
  texts.reduce(
    (max, text) =>
      text && text.includes("€") && text.length > max ? text.length : max,
    0
  );

/**
 * Allinea a destra un importo in euro dentro una colonna larga `width`
 * caratteri, anteponendo spazi non separabili (&nbsp;): in JetBrains Mono,
 * il carattere degli importi, sono larghi quanto una cifra. Lo spazio cifra
 * (&#8199;) JetBrains Mono non ce l'ha.
 * I testi che non sono importi tornano invariati.
 * @param {string} text
 * @param {number} width vedi priceColumnWidth
 * @returns {string} HTML
 */
export const alignPrice = (text, width) => {
  if (!text || !text.includes("€") || !width) return text;
  const pad = "&nbsp;".repeat(Math.max(width - text.length, 0));
  return `<span style="--font-family: var(--font-family-num)">${pad}${text}</span>`;
};
